import { lazyClosePreviewPane } from 'mini-preview-pane-view-actions';
import { mailItemViewReadingPaneRouteEntryHandler } from './mailItemReadingPaneRouteHandler';

export interface MailItemReadingPaneAttachmentPreviewRouteParameters {
    folderId: string;
    itemId: string;
    attachmentId: string;
}

/**
 * owa-router entry handler for item reading pane attachment preview pane
 */
export async function mailItemReadingPaneAttachmentPreviewRouteEntryHandler(
    params: MailItemReadingPaneAttachmentPreviewRouteParameters
): Promise<void> {
    const { folderId, itemId } = params;

    mailItemViewReadingPaneRouteEntryHandler({ folderId, itemId });
}

/**
 * owa-router exit handler for item reading pane attachment preview pane
 */
export async function mailItemReadingPaneAttachmentPreviewRouteExitHandler(
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
     * undefined
     *	> 'oldRoute' is defined but never used. */
    oldRoute: string[],
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any --
     * undefined
     * See aka.ms/mini-lint-errors
     *	> 'oldParams' is defined but never used.
     *	> Unexpected any. Specify a different type. */
    oldParams: any,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
     * undefined
     *	> 'newRoute' is defined but never used. */
    newRoute: string[],
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any --
     * undefined
     * See aka.ms/mini-lint-errors
     *	> 'newParams' is defined but never used.
     *	> Unexpected any. Specify a different type. */
    newParams: any
): Promise<boolean> {
    (await lazyClosePreviewPane.import())();
    return true;
}
